import { BaseEntityFieldsArray } from '@40seas/models';
import { CreditSafePortfolioEventRule } from './credit-safe-portfolio.event-rule.entity';
import { Omit } from '@40seas/entities/common';

export class CreateCreditSafePortfolioEventRuleDto extends Omit(CreditSafePortfolioEventRule, [...BaseEntityFieldsArray]) {}
